import { Box, Typography, Stack } from "@mui/material";
import { FaPlay } from "react-icons/fa";
import { MdStarRate } from "react-icons/md";
import { useNavigate } from "react-router-dom";
// import src from "../assets/images/i.jpg";

export const convertTime = (duration) => {
  let mmssFormat =
    duration < 3600
      ? new Date(duration * 1000).toISOString().substr(14, 5)
      : new Date(duration * 1000).toISOString().substr(11, 8);
  return mmssFormat;
};

export default function VideoThumbnail({
  src,
  duration,
  title,
  videoId,
  catagoryId,
  rating = "-",
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    const url = "/catagory/" + catagoryId + "/content/" + videoId;
    navigate(url);
  };

  const formatedDuration = convertTime(duration);
  return (
    <Stack
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      width={{ xs: "8rem", sm: "10rem" }}
      flexShrink={0}
      onClick={handleClick}
    >
      <Box
        position="relative"
        minHeight={{ xs: "5rem", sm: "7rem" }}
        sx={{
          "& #icon": { opacity: 0 },
          ":hover": {
            "& img": {
              opacity: 0.3,
            },
            "& #icon": {
              opacity: 1,
            },
          },
        }}
      >
        <img
          src={src}
          alt=""
          loading="lazy"
          style={{
            width: "100%",
            borderRadius: "0.4rem",
            transition: " 0.7s ease",
          }}
        />
        <FaPlay
          id="icon"
          fontSize="3rem"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            transition: " 0.7s ease",
            boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
          }}
        />
      </Box>
      <Typography textAlign="center" variant="body1">
        {title}
      </Typography>
      <Stack flexDirection="row" gap={0.5}>
        <Typography variant="body2">{`( ${rating} )`}</Typography>
        <MdStarRate size={16} />
      </Stack>
      <Typography
        width="min-content"
        px={1}
        py={0}
        mt={0.7}
        variant="caption"
        bgcolor="secondary.main"
        borderRadius={3}
      >
        {formatedDuration}
      </Typography>
    </Stack>
  );
}
